/* unplugin-vue-components disabled */import script from "./RoleCardAttribute.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCardAttribute.vue?vue&type=script&setup=true&lang=js"

import "./RoleCardAttribute.vue?vue&type=style&index=0&id=307cc160&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-307cc160"]])

export default __exports__